import { serialize } from 'object-to-formdata'
import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getBenefits({ date, interval = 0, endDate = null }) {
    return axiosIns.get(
      '/admin/benefits',
      {
        params: snakecaseKeys({
          date,
          interval,
          endDate,
        }),
      },
    )
  },
  createBenefits(benefitValues = []) {
    const formData = serialize(snakecaseKeys({
      benefits: benefitValues,
    }))

    return axiosIns.post('/admin/benefits/create_all', formData)
  },
  updateBenefits(benefitValues = []) {
    const formData = serialize(snakecaseKeys({
      benefits: benefitValues,
    }))

    return axiosIns.put('/admin/benefits/update_all', formData)
  },
  deleteBenefits(ids) {
    return axiosIns.delete(
      '/admin/benefits/destroy_all',
      {
        params: { ids },
      },
    )
  },
  saveAll({ benefits = [] }) {
    const formData = serialize(snakecaseKeys({ benefits }))

    return axiosIns.put('admin/benefits/save_all', formData)
  },
}
